export enum POS_OPERATIONS {
  CHECKOUT = 'CHECKOUT',
  REFUND = 'REFUND',
  VENUE_TRANSACTION = 'VENUE_TRANSACTION',
}
